import { Component, Input, OnInit } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from "@angular/forms";
import { debounceTime } from "rxjs/operators";
import { AuthService } from "src/app/services/auth.service";
import { CursosService } from "src/app/services/cursos.service";
import * as jQuery from "jquery";
import { PerfilService } from "src/app/services/perfil.service";
import { ActividadesService } from "src/app/services/actividades.service";
import { environment } from "src/environments/environment";

import { AlertController, InfiniteScrollCustomEvent } from "@ionic/angular";
import { ActivatedRoute } from "@angular/router";
import { ComponentDataService } from "src/app/services/component-data.service";
import { ToastService } from "src/app/services/toast.service";

@Component({
  selector: "app-estudiantes",
  templateUrl: "./estudiantes.component.html",
  styleUrls: ["./estudiantes.component.scss"],
})
export class EstudiantesComponent implements OnInit {
  @Input() public curso: any;
  @Input() public opcion: any;
  @Input() public data_estudiantes: any = [];
  @Input() public data_profesores: any;
  page = 1;
  totalpages = 0;

  deleteId = 0;
  search_op: number = 0;
  ID: number;
  AUTH_KEY: string;
  displayUserData: any;
  usersList: any = [];
  todos_cursos: any;
  calificaciones: any;
  certificados: any;
  setCer: any;
  email_list: any = [];
  correoFrom;
  idCurso;
  ids: any = [];
  isSubmitted: boolean = false;
  public searchControlUsers: FormControl;
  constructor(
    private cursosService: CursosService,
    private authService: AuthService,
    private perfilService: PerfilService,
    public actividadesService: ActividadesService,
    public formBuilder: FormBuilder,
    public alertController: AlertController,
    private activeRoute: ActivatedRoute,
    private componentDataService: ComponentDataService,
    public toastService: ToastService
  ) {
    this.searchControlUsers = new FormControl();
    this.idCurso = this.activeRoute.snapshot.paramMap.get("id_curso");
  }

  // submitForm() {
  //   this.isSubmitted = true;
  //   if (!this.emailForm.valid) {
  //     console.log("Please provide all the required values!");
  //     return false;
  //   } else {
  //     // if(this.email_list.indexOf(this.emailForm.value.correo) === -1) {
  //     this.sendEmailYii();
  //     this.addEmailListUser(this.emailForm.value.correo);

  //     // }else{
  //     //   this.alertMessage('El correo ya está en su lista');
  //     // }
  //   }
  // }
  // sendEmailYii(): Promise<any> {
  //   return new Promise((resolve) => {});
  // }
  // addEmailListUser(email: string) {
  //   let params = {
  //     email: email,
  //     id_curso: this.idCurso,
  //   };
  //   this.cursosService
  //     .addEmailListUserCurso(this.ID, this.AUTH_KEY, params)
  //     .subscribe((response) => {
  //       let list: any = response;
  //       if (list.auth_key && list.save) {
  //         this.email_list.push(this.emailForm.value.correo);
  //         this.emailForm.reset();
  //       }
  //     });
  // }
  getEmailListUser() {
    this.cursosService
      .getEmailListUser(this.ID, this.AUTH_KEY)
      .subscribe((response) => {
        let list: any = response;
        if (list.auth_key) {
          let lista: any = list.result;
          lista.forEach((element) => {
            this.email_list.push(element.correo);
          });
        }
      });
  }

  loadUserData() {
    let promise = new Promise((resolve) => {
      this.authService.userData$.subscribe((res: any) => {
        if (res) {
          if (!this.displayUserData) {
            this.displayUserData = res;
            this.ID = this.displayUserData?.id;
            this.AUTH_KEY = this.displayUserData?.auth_key;
            resolve(true);
          }
        }
      });
    });
    this.todos_cursos = [];
    promise.then((success) => {
      if (success) {
        this.setFilteredItems();
        let promise2 = new Promise((resolve) => {
          this.actividadesService
            .getAllActividadesCursos(this.AUTH_KEY, this.curso.id)
            .subscribe((response) => {
              console.log("getAllActividadesCursos: ", response);
              let cursos1: any = [];
              cursos1 = response;
              cursos1.forEach((element, i, array) => {
                this.todos_cursos.push({
                  id: element.data.id,
                  nombre: element.data.titulo,
                  tipo: 1,
                });
                if (i == array.length - 1) {
                  resolve(true);
                }
              });
            });
        });
        promise2.then(async (success2) => {
          if (success2) {
            if (this.data_estudiantes) {
              this.data_estudiantes.forEach((element) => {
                this.ids.push(element.id_user);
              });
            }
            await this.cursosService
              .getActividadCurso(this.ID, this.curso.id, this.AUTH_KEY, "1")
              .subscribe((res: any) => {
                let cursos2: any = [];
                cursos2 = res;
                console.log(
                  "file: estudiantes.component.ts:159 >> cursos2:",
                  cursos2
                );
                cursos2.forEach((element, i, array) => {
                  this.todos_cursos.push({
                    id: element.data[0].id,
                    nombre: element.data[0].nombre_actividad,
                    tipo: 2,
                    calificacion: element.calificacion,
                  });
                  console.log(
                    "file: estudiantes.component.ts:162 >> todos_cursos:",
                    this.todos_cursos
                  );
                  if (i == array.length - 1) {
                  }
                });
                this.calificaciones = this.todos_cursos;
              });

            // let promise3 = new Promise(resolve =>{
            await this.cursosService
              .getEstudiantesCurso(this.ID, this.AUTH_KEY, this.curso.id)
              .subscribe((resp) => {
                console.log(
                  "file: estudiantes.component.ts:177 >> getEstudiantesCurso:",
                  resp
                );
                if (resp.result) {
                  this.certificados = [];
                  this.certificados = resp.result;
                  console.log(
                    "file: estudiantes.component.ts:179 >> this.certificados:",
                    this.certificados
                  );
                }
              });
            // })
          }
        });
      }
      this.getEmailListUser();
    });
  }

  ngOnInit() {
    this.loadUserData();
    this.searchControlUsers.valueChanges.subscribe((searchText) => {
      this.usersList = [];
      this.page = 1;
      this.setFilteredItems(searchText);
    });
  }
  opcionCange() {
    let extBtn = document.getElementById("estudiante-add-btn");
    extBtn.click();
  }

  activar(id) {
    this.search_op = id;
  }

  setFilteredItems(search = "") {
    var data = {
      userFilter: search,
      id_curso: this.idCurso,
    };
    this.cursosService
      .getStudents(this.ID, this.AUTH_KEY, data, this.page)
      .subscribe((response) => {
        this.totalpages = response.totalPages;
        this.usersList.push(...response.result);
      });
  }
  isChekked(id): boolean {
    let check = false;
    this.data_estudiantes.forEach((element) => {
      if (element.id_user == id) {
        check = true;
      }
    });
    return check;
  }

  sendUsersToYii(data) {
    let params = {
      users_id: data.id,
      id_curso: this.idCurso,
    };
    this.cursosService
      .addEmailListUsersCurso(this.ID, this.AUTH_KEY, params)
      .subscribe((response) => {
        let list: any = response;
        if (list.auth_key) {
          this.toastService.presentToast("Se agregó el estudiante al curso");
          setTimeout(() => {
            window.location.reload();
          }, 200);
        }
      });
  }

  checkUsers(el) {
    let checkbox = jQuery(el.target);
    let id = jQuery(checkbox).data("id");
    console.log("checkUsers: ", id);
    let img = jQuery(checkbox).closest(".card-box").find(".img-chk");
    if (jQuery(checkbox).is(":checked")) {
      jQuery(img).addClass("active");
      this.ids.push(id);
      console.log("this.ids.push(id);: ", this.ids);
    } else {
      jQuery(img).removeClass("active");
      this.ids.forEach((element, i, array) => {
        if (element == id) {
          this.ids.splice(i, 1);
          console.log("this.ids.push(id);: ", this.ids);
        }
      });
    }
  }

  allDataUser(data) {
    this.perfilService
      .getPerfilByIds(this.ID, this.AUTH_KEY, data.id)
      .subscribe((res: any) => {
        let respuesta: any;
        respuesta = JSON.parse(res);
        if (respuesta.auth_key) {
          this.toastService.presentToast("Se agregó el estudiante al curso");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 200);
        }
      });
  }

  getUserImage(imagenes, imgDefault = false) {
    let imagen: string = null;
    if (imgDefault) {
      imagen = "assets/imagenes/profesor.png";
    }
    if (imagenes)
      if (imagenes.length > 0)
        imagenes.forEach((element) => {
          if (element.tipo == 2) {
            imagen = environment.host + "/" + element.url + element.name;
          }
        });
    return imagen;
  }

  deleteUser(id) {
    let element = document.getElementById("delete-user" + id);
    jQuery(element).fadeOut();
    this.data_estudiantes.forEach((element, i, array) => {
      if (element.id_user == id) {
        this.data_estudiantes.splice(i, 1);
      }
    });
    this.ids.forEach((element, i, array) => {
      if (element == id) {
        this.ids.splice(i, 1);
      }
      if (i == array.length - 1) {
        //this.selectUsers();
      }
    });
  }

  alertDelete(id) {
    let elements = document.getElementsByClassName("delete-user");
    jQuery(elements).fadeOut();
    if (this.deleteId != id) {
      this.deleteId = id;
      let element = document.getElementById("delete-user" + id);
      jQuery(element).fadeIn();
    } else {
      this.deleteId = 0;
    }
  }

  alertCertificado(id, op) {
    this.setCer = op;
    let elements = document.getElementsByClassName("delete-user");
    jQuery(elements).fadeOut();
    if (this.deleteId != id) {
      this.deleteId = id;
      let element = document.getElementById("certificate-user" + id);
      jQuery(element).fadeIn();
    } else {
      this.deleteId = 0;
    }
  }

  acceptCer(id) {
    let element = document.getElementById("certificate-user" + id);
    jQuery(element).fadeOut();
    console.log(
      "file: estudiantes.component.ts:376 >> this.ID, this.AUTH_KEY, this.curso.id, this.setCer:",
      id,
      this.AUTH_KEY,
      this.curso.id,
      this.setCer
    );
    this.cursosService
      .setCertificate(this.ID, this.AUTH_KEY, this.curso.id, id, this.setCer)
      .subscribe((response) => {
        console.log(
          "file: estudiantes.component.ts:177 >> getEstudiantesCurso:",
          response
        );
        if (!response.error) {
          this.cursosService
            .getEstudiantesCurso(this.ID, this.AUTH_KEY, this.curso.id)
            .subscribe((resp) => {
              if (resp.result) {
                this.certificados = [];
                this.certificados = resp.result;
                console.log(
                  "file: estudiantes.component.ts:179 >> this.certificados:",
                  this.certificados
                );
              }
            });
        }
      });
  }

  async alertMessage(message: string) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Información",
      subHeader: "",
      message: message,
      buttons: ["Aceptar"],
    });

    await alert.present();
  }
  addToSend(email: string) {
    this.sendMessage(email);
  }
  async sendMessage(email: string) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "¿Desea enviar la invitación?",
      subHeader: "",
      message: "Correo detino: " + email,
      buttons: [
        {
          text: "Aceptar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {
            console.log("Enviando...");
            //this.sendMessageToYii(email);
          },
        },
        {
          text: "Cancelar",
          handler: () => {
            console.log("Cancelado");
          },
        },
      ],
    });

    await alert.present();
  }
  // sendMessageToYii(email) {
  //   let params = {
  //     email: email,
  //     id_curso: this.idCurso,
  //   };
  //   this.cursosService
  //     .addEmailListUserCurso(this.ID, this.AUTH_KEY, params)
  //     .subscribe((response) => {
  //       let list: any = response;
  //       //console.log('list: ',list);
  //       if (list.auth_key && list.save) {
  //         this.email_list.push(this.emailForm.value.correo);
  //         this.emailForm.reset();
  //       }
  //     });
  // }

  viewActivity(student: any, activity: any) {
    console.log("file: estudiantes.component.ts:397 >> viewActivity");
    this.componentDataService.changeComponent.emit({
      option: 103,
      student,
      activity,
    });
  }

  async presentAlertConfirm(user) {
    const alert = await this.alertController.create({
      cssClass: "my-custom-class",
      header: "Confirmar",
      message: "¿Desea agregar el estudiante?",
      buttons: [
        {
          text: "Cancelar",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Proceder",
          handler: () => {
            this.sendUsersToYii(user);
          },
        },
      ],
    });

    await alert.present();
  }

  onIonInfinite(event) {
    console.log(
      "🚀 ~ EstudiantesComponent ~ onIonInfinite ~ this.page:",
      this.page
    );
    if (this.page == this.totalpages) {
      (event as InfiniteScrollCustomEvent).target.disabled = true;
    } else {
      this.page++;
      this.setFilteredItems();
      setTimeout(() => {
        (event as InfiniteScrollCustomEvent).target.complete();
      }, 500);
    }
  }
}
